import ReportTableSubheader from './ReportTableSubheader'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    indicatorsData: state.INDICATORS.indicatorsData,
    lastUpdated: state.INDICATORS.lastUpdated
  }
}

export default withRouter(connect(mapStateToProps)(ReportTableSubheader))




// WEBPACK FOOTER //
// ./src/components/ReportTableSubheader/index.js